import React from 'react';
import { Grid, Stack, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';
import { PortalConfigurationType, VendorProfile } from '@trnsact/trnsact-shared-types';
import { PortalConfiguration, PortalConfigurationRenderProps } from '../../types';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { PortalManagementForm } from './PortalManagementForm';
import { getConfigToSave } from '../lib';
import { PortalConfig, PortalManagementFormValues } from '../types';
import { portalManagementApi } from '../api';
import { useMutation } from '@apollo/client';

export const PortalManagement = ({ loading, onSaveConfiguration }: PortalConfigurationRenderProps) => {
  const vendorProfile = useSelector((state: any) => state.vp) as VendorProfile;

  const portalConfiguration = useSelector((state: any) =>
    portalConfigurationsSelectors.configDataByType(state, PortalConfigurationType.Portal)
  ) as PortalConfiguration<PortalConfig>;

  const [updateVendorProfile] = useMutation(portalManagementApi.updateVendorProfile);

  const handleSave = async (formData: PortalManagementFormValues) => {
    try {
      const configToSave = getConfigToSave(portalConfiguration, formData);
      await onSaveConfiguration(configToSave);
      await updateVendorProfile({
        variables: {
          entityId: vendorProfile.id,
          fieldsObj: {
            multiLocationManagement: formData.multiLocationManagement,
          },
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Grid item sm={12} md={6}>
      <CardContainer title="Portal">
        <RenderWithFallback
          isLoading={!portalConfiguration || !vendorProfile}
          fallBack={
            <Stack alignItems="center" justifyContent="center" height="100%">
              <CircularProgress />
            </Stack>
          }
        >
          <PortalManagementForm
            isLoading={loading}
            onConfirm={handleSave}
            vendorProfile={vendorProfile}
            portalConfigurationConfig={portalConfiguration?.jsonDefinition?.config}
          />
        </RenderWithFallback>
      </CardContainer>
    </Grid>
  );
};
